import $ from 'jquery'
import constants from 'scoreboard/components/constants'

/**
 * Unicode codepoint version of CurrencyUtil.SAUDI_RIYAL_PLACEHOLDER_HTML_ENCODED
 */
const SAUDI_RIYAL_PLACEHOLDER_UNICODE = '\uE900'
const SAUDI_RIYAL_PLACEHOLDER_UNICODE_REGEX =
	new RegExp(SAUDI_RIYAL_PLACEHOLDER_UNICODE, 'g')

/**
 * Adds a listener to convert non-standard Unicode currency characters to the
 * plain alphabetical currency code. This is necessary for copying and pasting
 * into an application that doesn't have the "Saudi Riyal" font installed
 * (which is most applications). See #63387
 */
function setupCurrencyCopyListener () {
	$(document).on('copy', e => {
		const selection = window.getSelection().toString()
		if (selection.includes(SAUDI_RIYAL_PLACEHOLDER_UNICODE)) {
			// Prevent the default copy behavior
			e.preventDefault()

			// Replace the placeholder "private use area" code and replace with
			// the alphabetical representation.
			const modifiedText = selection.replace(
				SAUDI_RIYAL_PLACEHOLDER_UNICODE_REGEX,
				constants.SAUDI_RIYAL_PLACEHOLDER_ALPHA)
			e.originalEvent.clipboardData?.setData('text/plain', modifiedText)
		}
	})
}

export default setupCurrencyCopyListener

setupCurrencyCopyListener.__filename__ = 'setup-currency-copy-listener.js'
